import styles from './occasion_card.module.scss';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {VehicleBrandModel} from '../../../components/vehicle/vehicle_brand_model.tsx';
import {Spacer} from '../../../components/utility/spacer.tsx';
import {classNames} from '../../../support/classnames.ts';

export function OccasionPlaceholder() {
    return (
        <div className={classNames(styles.occasion, styles.occasion_placeholder)}>
            <div className={styles.occasion_slider} style={{background: 'var(--border-color)', padding: '75% 0 0 0'}} />

            {/*BRAND MODEL*/}
            <FlexRow alignment={Alignment.Center}>
                <VehicleBrandModel brand={null} model={null} />
            </FlexRow>

            <Spacer />

            <FlexRow alignment={Alignment.Center}>
                <span className={styles.placeholder} style={{width: '30%'}} />
            </FlexRow>

            <Spacer />

            <div className={styles.occasion_icons}>
                {['fa-light fa-gear', 'fa-light fa-gas-pump', 'fa-light fa-gauge', 'fa-light fa-calendar'].map(
                    (c, i) => (
                        <span className={styles.icon_item} key={i}>
                            <i style={{color: 'var(--text-muted-color)'}} className={c}></i>
                            <span>
                                <span style={{minWidth: '30px'}} className={styles.placeholder} />
                            </span>
                        </span>
                    ),
                )}
            </div>
        </div>
    );
}
